import axios from "axios";
import { MSGS } from "../constants/messages.js";

/**
 * Base URL:
 * - Usa VITE_API_URL se definido e não vazio
 * - Se vazio ou undefined, usa URL relativa /api
 */
const baseURL = import.meta.env.VITE_API_URL
  ? import.meta.env.VITE_API_URL.replace(/\/$/, "")
  : "/api";

/** Utils para mensagens */
function ucfirst(s = "") {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}
function currentPageSegment() {
  try {
    const path = window.location?.pathname || "";
    const parts = path.split("/").filter(Boolean); // ex.: ["painel","especialistas"]
    const seg = parts.length >= 2 && parts[0] === "painel" ? parts[1] : parts[parts.length - 1];
    return ucfirst((seg || "").replace(/-/g, " "));
  } catch {
    return "";
  }
}

/** Normalização de erro (mesma convenção do httpInterceptor) */
function normalizeError(error) {
  const page = currentPageSegment();
  const resp = error?.response;
  const status = resp?.status;

  error.page = page;

  if (!resp) {
    error.kind = "exception";
    error.userMessage = `Não foi possível carregar ${page || "os dados"}. Verifique sua conexão e tente novamente.`;
    return error;
  }
  if (status === 422) {
    error.kind = "validation";
    error.validationErrors = resp.data?.errors || {};
    error.userMessage = "Por favor, corrija os erros no formulário.";
    return error;
  }
  if (status === 401) {
    error.kind = "unauthorized";
    error.userMessage = MSGS.SESSAO_EXPIRADA;
    return error;
  }
  if (status === 403) {
    error.kind = "permission";
    error.userMessage = "Acesso não permitido.";
    return error;
  }
  if (status === 404) {
    error.kind = "not_found";
    // Usa mensagem do servidor se disponível, senão usa genérica
    error.userMessage = resp.data?.message || "Recurso não encontrado.";
    return error;
  }
  if (status >= 500) {
    error.kind = "server";
    error.userMessage = "Erro interno do servidor. Tente novamente.";
    return error;
  }
  error.kind = "exception";
  error.userMessage = resp.data?.message || "Ocorreu um erro ao processar a solicitação.";
  return error;
}

/**
 * Instância da API
 */
const api = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
  withCredentials: false, // API stateless - sem cookies
});

/** Interceptor de request: injeta Bearer a partir de auth_token */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/** Interceptor de response: normaliza erros na própria instância */
api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(normalizeError(error))
);

export default api;
